import {
  AUTH_STATUS_APPROVE,
  AUTH_STATUS_AR,
  AUTH_STATUS_WARNING,
} from "constants/FormatDataContanst";
import "flatpickr/dist/themes/material_blue.css";
import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Progress,
  Row,
} from "reactstrap";
import { invoiceCampaignDetail } from "store/actions";
import {
  executeReport,
  getReportInvoiceProgress,
  resetExecuteReport,
  resetGetReportInvoiceProgress,
} from "store/summary-invoice-data/actions";
import {
  EXECUTE_REPORT_FAIL,
  EXECUTE_REPORT_SUCCESS,
} from "store/summary-invoice-data/actionTypes";
import ListInvoiceCampaign from "./ListInvoiceCampaign";

const DetailData = props => {
  const { isOpenModal, dataDetail, toggleModal, t, openReleaseModal } = props;
  const dispatch = useDispatch();
  // store reducer
  const summaryInvoiceData = useSelector(state => state.summaryInvoiceData);
  const {
    reportInvoiceProgress,
    executeReportData,
    type: typeReport,
  } = summaryInvoiceData;
  const childRef = useRef();

  const issueInvoice = useSelector(state => state.issueInvoice);
  const { invoiceCampaignDetailData } = issueInvoice;
  const { addToast } = useToasts();

  useEffect(() => {
    if (isOpenModal) {
      switch (typeReport) {
        case EXECUTE_REPORT_SUCCESS: {
          addToast("Import lô hóa đơn thành công", {
            appearance: "success",
            autoDismiss: true,
          });
          dispatch(
            getReportInvoiceProgress(
              invoiceCampaignDetailData?.data.report_id,
              true
            )
          );
          dispatch(resetExecuteReport());
          break;
        }
        case EXECUTE_REPORT_FAIL:
          addToast("Import lô hóa đơn thất bại", {
            appearance: "error",
            autoDismiss: true,
          });
          dispatch(resetExecuteReport());
          break;
      }
    }
  }, [typeReport]);

  useEffect(() => {
    if (isOpenModal) {
      dispatch(invoiceCampaignDetail(dataDetail.id));
    } else {
      dispatch(resetGetReportInvoiceProgress());
    }
  }, [isOpenModal]);

  useEffect(() => {
    if (
      invoiceCampaignDetailData &&
      isOpenModal &&
      invoiceCampaignDetailData?.data &&
      reportInvoiceProgress?.percent !== 100
    ) {
      dispatch(
        getReportInvoiceProgress(
          invoiceCampaignDetailData?.data.report_id,
          true
        )
      );
    }
  }, [invoiceCampaignDetailData]);

  useEffect(() => {
    // Tiến độ 100% thì gọi query hóa đơn
    if (
      !reportInvoiceProgress.isStart &&
      reportInvoiceProgress?.percent === 100
    ) {
      dispatch(invoiceCampaignDetail(dataDetail.id));
      childRef?.current?.queryDataListInvoice();
    }
  }, [reportInvoiceProgress]);

  const modal = useRef(null);

  return (
    <React.Fragment>
      <Modal
        isOpen={isOpenModal}
        toggle={toggleModal}
        size="xl"
        role="dialog"
        autoFocus={true}
        centered={true}
        className="exampleModal"
        contentClassName="detail-data-format"
        style={{ maxWidth: "99%" }}
      >
        <ModalHeader toggle={toggleModal}>Thông tin lô hóa đơn</ModalHeader>
        <React.Fragment>
          <ModalBody>
            <Row className="d-flex justify-content-center">
              <div style={{ width: "50vw" }}>
                <div
                  className="d-flex justify-content-center align-items-end gap-2"
                  style={{ fontSize: "17px" }}
                >
                  {/* <i className=" far fa-file-excel text-success font-size-20" /> */}
                  {/* <strong>{nameFile + ".xlsx "}</strong> */}
                  {reportInvoiceProgress.percent === 100
                    ? ""
                    : "(Đang xử lý file upload)"}
                </div>
                <Progress
                  style={{ height: "33px" }}
                  animated
                  color="info"
                  striped
                  value={reportInvoiceProgress.percent}
                >
                  <span style={{ fontSize: "20px" }}>
                    {reportInvoiceProgress.percent === 100 && "Hoàn tất xử lý"}{" "}
                    ({reportInvoiceProgress.percent + "%"})
                  </span>
                </Progress>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "15px",
                  justifyContent: "center",
                  fontSize: "18px",
                  marginTop: "3px",
                  lineHeight: "15px",
                  alignItems: "center",
                }}
              >
                <i
                  className="dripicons-clockwise text-info"
                  style={{
                    fontSize: "30px",
                    cursor: "pointer",
                  }}
                  title={"Reload thông tin"}
                  onClick={() => {
                    dispatch(invoiceCampaignDetail(dataDetail.id));
                    childRef?.current?.queryDataListInvoice();
                  }}
                />

                <div className="text-primary">
                  Id lô hóa đơn: {invoiceCampaignDetailData?.data?.id}
                </div>
                {invoiceCampaignDetailData?.data?.report?.status ===
                  AUTH_STATUS_APPROVE && (
                  <React.Fragment>
                    <div className="text-info">
                      Tổng số hóa đơn:{" "}
                      {invoiceCampaignDetailData?.data?.quantity
                        ?.total_quantity || 0}
                    </div>
                    <div className="text-success">
                      Đã phát hành:{" "}
                      {invoiceCampaignDetailData?.data?.quantity
                        ?.approve_quantity || 0}
                    </div>
                    <div className="text-warning">
                      Chờ phát hành:{" "}
                      {invoiceCampaignDetailData?.data?.quantity
                        ?.pending_quantity || 0}
                    </div>
                    <div className="text-danger">
                      Đã từ chối:{" "}
                      {invoiceCampaignDetailData?.data?.quantity
                        ?.reject_quantity || 0}
                    </div>
                  </React.Fragment>
                )}
              </div>
            </Row>

            <div
              ref={modal}
              style={{
                maxHeight: "70vh",
                overflow: "auto",
                paddingLeft: "20px",
                paddingRight: "20px",
              }}
            >
              {/* {(reportInvoiceProgress.isStart ||
                    reportInvoiceProgress.percent !== 0) && ( */}
              {reportInvoiceProgress.percent === 100 && (
                <React.Fragment>
                  {invoiceCampaignDetailData?.data?.report?.status ===
                  AUTH_STATUS_APPROVE ? (
                    <ListInvoiceCampaign
                      ref={childRef}
                      campaign_id={dataDetail?.id}
                      t={t}
                    ></ListInvoiceCampaign>
                  ) : invoiceCampaignDetailData?.data?.report?.log ? (
                    <React.Fragment>
                      {invoiceCampaignDetailData?.data?.report?.status ===
                      AUTH_STATUS_WARNING ? (
                        <React.Fragment>
                          {" "}
                          <div
                            style={{ fontSize: "25px" }}
                            className="d-flex gap-1 align-items-center"
                          >
                            <i className="bx bx-info-circle text-warning "></i>
                            Cảnh báo:
                          </div>
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          {" "}
                          <div
                            style={{
                              fontSize: "25px",
                            }}
                            className="d-flex gap-1 align-items-center"
                          >
                            <i className="bx bx-info-circle text-danger "></i>
                            Lỗi:
                          </div>
                        </React.Fragment>
                      )}

                      <div
                        style={{
                          fontSize: "16px",
                          maxHeight: "67vh",
                          overflow: "auto",
                        }}
                        dangerouslySetInnerHTML={{
                          __html: invoiceCampaignDetailData?.data?.report?.log,
                        }}
                      ></div>
                    </React.Fragment>
                  ) : (
                    <div className="text-success font-size-20 text-center">
                      Hoàn tất validate .Vui lòng nhấn import lô hóa đơn
                    </div>
                  )}{" "}
                </React.Fragment>
              )}
            </div>
          </ModalBody>
          <ModalFooter>
            <Button
              type="button"
              color="danger"
              className="me-2"
              onClick={toggleModal}
            >
              Đóng
            </Button>
            {reportInvoiceProgress?.percent === 100 &&
              reportInvoiceProgress?.status === AUTH_STATUS_APPROVE &&
              (invoiceCampaignDetailData?.data?.report?.status ===
                AUTH_STATUS_WARNING ||
                invoiceCampaignDetailData?.data?.report?.status ===
                  AUTH_STATUS_AR) && (
                <Button
                  color="info"
                  className="btn-label"
                  type="button"
                  disabled={executeReportData.loading}
                  onClick={() => {
                    dispatch(resetGetReportInvoiceProgress());
                    dispatch(
                      executeReport(invoiceCampaignDetailData?.data?.report_id)
                    );
                  }}
                >
                  <i className="fas fa-file-import label-icon"></i>
                  Import lô hóa đơn
                </Button>
              )}
            {reportInvoiceProgress?.percent === 100 &&
              invoiceCampaignDetailData?.data?.report?.status ===
                AUTH_STATUS_APPROVE &&
              invoiceCampaignDetailData?.data?.can_release &&
              invoiceCampaignDetailData?.data?.is_release === 0 && (
                <Button
                  color="success"
                  className="btn-label"
                  type="button"
                  disabled={reportInvoiceProgress?.percent !== 100}
                  onClick={() => {
                    //   toggleConfirmExportModal();
                    openReleaseModal(invoiceCampaignDetailData?.data?.id);
                  }}
                >
                  <i className="bx bx-send label-icon"></i>
                  Phát hành lô hóa đơn
                </Button>
              )}
          </ModalFooter>
        </React.Fragment>
      </Modal>
    </React.Fragment>
  );
};

DetailData.propTypes = {
  isOpenModal: PropTypes.bool.isRequired,
  toggleModal: PropTypes.func.isRequired,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  openReleaseModal: PropTypes.any,
};

DetailData.defaultProps = {
  isOpenModal: false,
};

export default DetailData;
